import { Requisicion } from './Requisicion';
import { Usuario } from './usuario';

export class CambioEstadoRequisicion {
    constructor(
        public id:                      number,
        public fecha:                   string,
        public estadoAnterior:          string,
        public estadoPosterior:         string,
        public observaciones:           string,

        // Relaciones
        public UsuarioId: number,
        public RequisicionId: number,
    ){}

    requisicion: Requisicion;
    usuario: Usuario;
    fechaFormato: string;
    fechaDate: Date;
}